$("body").on("click", '.btn-upload', function (ev) {
    var url = $(this).data('url');
    $('#upload-modal').find("iframe").attr('src', url);
});

var formNewsletters = document.getElementById('form-newsletters') || null;


if (formNewsletters) {
    formNewsletters.addEventListener('submit', function (ev) {
        ev.preventDefault();
    });

    var btnSubscriptionNewsletter = document.getElementById('btn-subscription-newsletter');

    btnSubscriptionNewsletter.addEventListener('click', function (ev) {

        var newsletterSubscribe = document.getElementById('newsletter_subscribe');
        var newsletterAgreement = document.getElementById('newsletter_agreement');
        if (newsletterSubscribe.checkValidity() && newsletterAgreement.checkValidity()) {
            axios.post(btnSubscriptionNewsletter.getAttribute('data-url'), {
                email: newsletterSubscribe.value,
                privacy: newsletterAgreement.checked
            })
                .then(res => {
                    if (res.data.success) {
                        document.getElementById('messages').classList.remove('alert', 'alert-success', 'alert-warning');
                        document.getElementById('messages').classList.add('alert', 'alert-success');
                        document.getElementById('messages').innerText = res.data.msg;
                        document.getElementById('newsletter_subscribe').value = '';
                        document.getElementById('newsletter_agreement').checked = false;
                        formNewsletters.style.display = "none";
                    } else {
                        document.getElementById('messages').classList.remove('alert', 'alert-success', 'alert-warning');
                        document.getElementById('messages').classList.add('alert', 'alert-warning');
                        var str = '';
                        res.data.error.forEach(value => {
                            str += '<p>' + value + '</p>';
                        })
                        document.getElementById('messages').innerHTML = str;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }

    });
}

function validateFormInputlllll(element) {
    var validity = element.checkValidity();
    if( !validity ) {
        $(element).addClass("is-invalid");
        $(element).siblings(".invalid-feedback").text(element.validationMessage);
    }
    else {
        $(element).removeClass("is-invalid");
        $(element).siblings(".invalid-feedback").text();
    }
}

$(".form-label-group input").blur(function () {
    var self = this;
    var validity = self.checkValidity();
    if( !validity ) {
        $(self).addClass("is-invalid");
        $(self).siblings(".invalid-feedback").text(self.validationMessage);
    }
    else {
        $(self).removeClass("is-invalid");
        $(self).siblings(".invalid-feedback").text();
    }
})

// megamenu
document.addEventListener("DOMContentLoaded", function(){
    /////// Prevent closing from click inside dropdown
    document.querySelectorAll('.dropdown-menu').forEach(function(element){
        element.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    })
});

// overlay chiaro megamenu
    document.addEventListener("DOMContentLoaded", function (){

    document.querySelectorAll('.navbar .dropdown').forEach(function (everydropdown) {

        everydropdown.addEventListener('shown.bs.dropdown', function () {
            el_overlay = document.createElement('span');
            el_overlay.className = 'screen-lighten';
            document.body.appendChild(el_overlay)
        });

        everydropdown.addEventListener('hide.bs.dropdown', function () {
            document.body.removeChild(document.querySelector('.screen-lighten'));
        });

    });

});

$(document).on('focus', '.select2.select2-container', function (e) {
    // only open on original attempt - close focus event should not fire open
    if (e.originalEvent && $(this).find(".select2-selection--single").length > 0) {
        $(this).siblings('select').select2('open');
    }
});

$(document).on("shown.bs.modal", '#searchModal', function() {
    $('#search-input').focus();
});

$('#search-button').click(function(e) {
    $('#search-input').attr("disabled", "disabled");
    let query = $("#search-input").val();
    search(query, 1);
    $('#search-input').removeAttr("disabled");
});

$('#search-input').on('keydown', function (e) {
    if(e.which === 13){
        $('#search-button').click();
    }
});

function search(query, page) {
    $('#search-results').html("");
    $('#search-spinner').show();

    axios.post("/search", {
        query: query,
        page: page
    })
    .then(function (response) {
        $('#search-spinner').hide();
        $('#search-results').html(response.data);
    });
}

if($('.infinite-scroll').length > 0) {
    $('ul.pagination').hide();
    $('.infinite-scroll').jscroll({
        autoTrigger: true,
        loadingHtml: '<div class="text-center pt-2"><i class="fa-solid fa-spinner fa-spin-pulse fa-2x"></i></div>',
        padding: 0,
        nextSelector: '.pagination li.active + li a',
        contentSelector: 'div.infinite-scroll',
        callback: function() {
            $('ul.pagination').remove();
        }
    });
}

